
// Create array of search-custom objects
// Each object takes an array of terms (user input) and an array of suggestions for those terms
// Each suggestion item takes a title and an optional link
// If no link exists, link will be a product search for the given title
var searchCustom = [
  {
    terms : ['payment', 'finan', 'plan', 'humm'],
    suggestions : [
      {
        title : 'Humm Payment Plans',
        link : '/pages/payment-plans',
        image: 'https://cdn.shopify.com/s/files/1/1090/1794/files/search-link_humm_200x.jpg?v=1727878589'
      }
    ]
  },
  {
    terms : ['blog', 'journal', 'article'],
    suggestions : [
      {
        title : 'The Chupi Journal',
        link : '/blogs/all',
        image: 'https://cdn.shopify.com/s/files/1/1090/1794/files/search-link_blog_200x.jpg?v=1727882700'
      }
    ]
  },
  {
    terms : ['care', 'customer', 'support', 'faq'],
    suggestions : [
      {
        title : 'Chupi Customer Care',
        link : 'https://care.chupi.com/'
      }
    ]
  },
  // {
  //   terms : ['finder', 'quiz', 'erq'],
  //   suggestions : [
  //     {
  //       title : 'The Chupi Engagement Ring Finder',
  //       link : '/pages/the-chupi-engagement-ring-finder'
  //     }
  //   ]
  // },
  {
    terms : ['virt', 'virtual'],
    suggestions : [
      {
        title : 'Virtual Try-On',
        link : 'https://try-on.chupi.com/',
        image: 'https://cdn.shopify.com/s/files/1/1090/1794/files/search-link_vto_200x.jpg?v=1727879216'
      },
      {
        title : 'Book an Appointment',
        link : '/pages/book-an-appointment',
        image: 'https://cdn.shopify.com/s/files/1/1090/1794/files/search-link_appointment_200x.jpg?v=1727879763'
      }
    ]
  },
  {
    terms : ['tryon', 'try-on', 'visual', 'ring visual', 'vr'],
    suggestions : [
      {
        title : 'Virtual Try-On',
        link : 'https://try-on.chupi.com/',
        image: 'https://cdn.shopify.com/s/files/1/1090/1794/files/search-link_vto_200x.jpg?v=1727879216'
      }
    ]
  },
  {
    terms : ['appoin', 'apoin', 'consultation'],
    suggestions : [
      {
        title : 'Book an Appointment',
        link : '/pages/book-an-appointment',
        image: 'https://cdn.shopify.com/s/files/1/1090/1794/files/search-link_appointment_200x.jpg?v=1727879763'
      }
    ]
  },
  {
    terms : ['digital rin', 'digital siz', 'sizer dig', 'ring dig', 'online sizer', 'online ring'],
    suggestions : [
      {
        title : 'Chupi Digital Ring Sizer',
        link : 'https://ringsizer.chupi.com/',
        image: 'https://cdn.shopify.com/s/files/1/1090/1794/files/search-link_ring-sizer_200x.jpg?v=1727880351'
      }
    ]
  },
  {
    terms : ['cart', 'checkout'],
    suggestions : [
      {
        title : 'Shopping Bag',
        link : '/cart'
      }
    ]
  },
  {
    terms : ['call', 'phone', 'email'],
    suggestions : [
      {
        title : 'Contact Us',
        link : '/pages/contact'
      }
    ]
  },
  {
    terms : ['job', 'career'],
    suggestions : [
      {
        title : 'Careers at Chupi',
        link : '/pages/careers-at-chupi'
      }
    ]
  }
  // {
  //   terms : ['black fr', 'black friday', 'friday', 'bfcm'],
  //   suggestions : [
  //     {
  //       title : 'Signup for Black Friday',
  //       link : '/pages/chupi-black-friday-2024',
  //       //image: 'https://cdn.shopify.com/s/files/1/1090/1794/files/search-link_bfcm-signup_200x.jpg?v=1727882216'
  //       image: 'https://cdn.shopify.com/s/files/1/1090/1794/files/search-link_black-friday_200x.jpg?v=1730288446'
  //     }
  //   ]
  // }
];
